declare var Mongo: any;

export const AppManagerCollection = new Mongo.Collection('appManagers');
export const InstalledAppCollection = new Mongo.Collection('installedApps');
export const CalendarEventCollection = new Mongo.Collection('calendarEvents');
export const ChatMessageCollection = new Mongo.Collection('chatMessages');
export const GroupChatCollection = new Mongo.Collection('groupChats');
export const NotificationCollection = new Mongo.Collection('notifications');
export const TypingStatusCollection = new Mongo.Collection('typingStatus');